<template>
	<el-dialog title="素材库" :visible="show" :append-to-body="true" width="100%"
			:before-close="handleClose" class="dialog_diy">
			<div style="width: 100%;height: 100%;">
					<fileBox type="2" ref="fileBoxRef" @addFile="addFile"></fileBox>
			</div>
	</el-dialog>    
</template>

<script>
import fileBox from '../../library.vue';
export default {
	components: {
			fileBox,
	},
	props: {

	},
	data() {
			return {
					show:false,
					progress: 0,
					isFinishSize: 0,
					proVisible: false,
					isAllSize: 0,
					dialogVisiblefile2: false,
					userid: this.$route.query.userid,
					page: 1,
					isLoading: false,
					total: 0,
					chapInfo: [],
					choose: 0,
					mtp: require("../../../../assets/tup1.png"),
					msp: require("../../../../assets/icon/fileIcon/isVideo.png"),
					mfj: require("../../../../assets/icon/fileIcon/word2.png"),
			};
	},
	methods: {
		open(){
			this.show = true;
			this.$refs.fileBoxRef.getData();
		},
		handleClose(done) {
			this.close();
					done();
			},
			handleClose2(done) {
					done();
			},
			close() {
				this.show = false;
			},
			addFile(file){
					this.$emit("addFile",file);
					this.close();
			}

	}   
};
</script>

<style scoped>
.dialog_diy>>>.el-dialog {
	height: 100%;
	margin: 0 auto !important;
}

.dialog_diy>>>.el-dialog__header {
	background: #454545 !important;
	padding: 15px 20px;
}

.dialog_diy>>>.el-dialog__body {
	height: calc(100% - 55px);
	box-sizing: border-box;
	padding: 0px;
}

.dialog_diy>>>.el-dialog__title {
	color: #fff;
}

.dialog_diy>>>.el-dialog__headerbtn {
	top: 19px;
}

.dialog_diy>>>.el-dialog__headerbtn .el-dialog__close {
	color: #fff;
}

.dialog_diy>>>.el-dialog__headerbtn .el-dialog__close:hover {
	color: #fff;
}

.dialog_diy>>>.el-dialog__body,
.dialog_diy>>>.el-dialog__footer {
	background: #fafafa;
}


</style>



// WEBPACK FOOTER //
// src/components/pages/classroomObservation/components/resourceLibraryDialog.vue